import actionsCard from "src/assets/imgs/dashboardTemplate/actionsCard.png";
import actionsChart from "src/assets/imgs/dashboardTemplate/actionsChart.png";
import actionsPieChart from "src/assets/imgs/dashboardTemplate/actionsPieChart.png";
import actionsList from "src/assets/imgs/dashboardTemplate/actionsList.png";
import businessDiagnosis from "src/assets/imgs/dashboardTemplate/businessDiagnosis.png";
import canvas from "src/assets/imgs/dashboardTemplate/canvas.png";
import indicatorsCard from "src/assets/imgs/dashboardTemplate/indicatorsCard.png";
import indicatorsChart from "src/assets/imgs/dashboardTemplate/indicatorsChart.png";
import indicatorsList from "src/assets/imgs/dashboardTemplate/indicatorsList.png";
import indicatorsGauge from "src/assets/imgs/dashboardTemplate/indicatorsGauge.png";
import map from "src/assets/imgs/dashboardTemplate/map.png";
import myActionsList from "src/assets/imgs/dashboardTemplate/myActionsList.png";
import okrsCard from "src/assets/imgs/dashboardTemplate/okrsCard.png";
import okrsCardWithKrs from "src/assets/imgs/dashboardTemplate/okrsCardWithKrs.png";
import okrsList from "src/assets/imgs/dashboardTemplate/okrsList.png";
import projectsCard from "src/assets/imgs/dashboardTemplate/projectsCard.png";
import projectsCardPercentage from "src/assets/imgs/dashboardTemplate/projectsCardPercentage.png";
import projectsCardPercentageProgram from "src/assets/imgs/dashboardTemplate/projectsCardPercentageProgram.png";
import projectsPieChart from "src/assets/imgs/dashboardTemplate/projectsPieChart.png";
import projectsListCards from "src/assets/imgs/dashboardTemplate/projectsListCards.png";
import swot from "src/assets/imgs/dashboardTemplate/swot.png";
import occurrecesListCards from "src/assets/imgs/dashboardTemplate/occurrecesListCards.png";  
import myOcurrences from "src/assets/imgs/dashboardTemplate/myOcurrences.png";
import risksPieChartProbability from "src/assets/imgs/dashboardTemplate/risksPieChartProbability.png";
import risksPieChartImpact from 	"src/assets/imgs/dashboardTemplate/risksPieChartImpact.png";
import risksListClassification from "src/assets/imgs/dashboardTemplate/risksListClassification.png";
import indicatorsListSector from "src/assets/imgs/dashboardTemplate/indicatorsListSector.png";
import occurrencesListCardsSector from "src/assets/imgs/dashboardTemplate/occurrencesListCardsSector.png";
import projectsListSector from "src/assets/imgs/dashboardTemplate/projectsListSector.png";
import actionsListSector from "src/assets/imgs/dashboardTemplate/actionsListSector.png";
import okrsListSector from "src/assets/imgs/dashboardTemplate/okrsListSector.png";
import auditsListType from "src/assets/imgs/dashboardTemplate/auditsListType.png";
import auditsListSector from "src/assets/imgs/dashboardTemplate/auditsListSector.png";
import audtisListProcess from "src/assets/imgs/dashboardTemplate/audtisListProcess.png";
import auditsPieChart from "src/assets/imgs/dashboardTemplate/auditsPieChart.png";
import meetingsList from "src/assets/imgs/dashboardTemplate/meetingsList.png";

import DashboardCardsActions from "./Templates/Actions/Cards";
import DashboardListsActions from "./Templates/Actions/List";
import BusinessDiagnosisCards from "./Templates/BusinessDiagnosis";
import CanvasCards from "./Templates/Canvas";
import DashboardListsIndicators from "./Templates/Indicators/List";
import DashboardListClassificationIndicators from "./Templates/Indicators/ListClassification";
import DashboardCardsIndicators from "./Templates/Indicators/Cards";
import DashboardChartIndicators from "./Templates/Indicators/Chart";
import { FormatDashboard, IDashboardTemplate, TypeDashboardComponents } from "./interface";
import MapsCards from "./Templates/Maps";
import SWOTSCards from "./Templates/SWOT";
import DashboardChartClassificationIndicators from "./Templates/Indicators/ChartClassification";
import DashboardGaugeIndicators from "./Templates/Indicators/Gauge";
import DashboardChartActions from "./Templates/Actions/Chart";
import DashboardListMyActionsActions from "./Templates/Actions/ListMyActions";
import DashboardListActionsActions from "./Templates/Actions/ListActions";
import DashboardPieChartActions from "./Templates/Actions/PieChart";
import DashboardCardSpecificProject from "./Templates/Projects/Cards";
import DashboardPieChartProjectsOfProgram from "./Templates/Projects/PieChartOfProgram";
import DashboardPieChartProjects from "./Templates/Projects/PieChart";
import DashboardListProjects from "./Templates/Projects/List";
import DashboardCardsProjectsPercentage from "./Templates/Projects/CardsPercentage";
import DashboardCardsProjectsPercentageOfProgram from "./Templates/Projects/CardsPercentageOfProgram";
import OKRsCards from "./Templates/OKRs/Card";
import DashboardCardsOKRWithKRs from "./Templates/OKRs/CardOKRWithKRs";
import DashboardListClassificationOKRs from "./Templates/OKRs/List";
import DashboardListsOccurrences from "./Templates/Occurrences/ListOrigin";
import DashboardListMyOccurrences from "./Templates/Occurrences/ListMyOccurrences";  
import DashboardPieChartRisksImpact from "./Templates/Risks/PieChartImpact";
import DashboardPieChartRisksProbability from "./Templates/Risks/PieChartProbability";
import DashboardListClassificationRisks from "./Templates/Risks/List";
import DashboardListsIndicatorsSectors from "./Templates/Indicators/ListSector";
import DashboardListsOccurrencesSector from "./Templates/Occurrences/ListSector";
import DashboardListsActionsSector from "./Templates/Actions/ListSector";
import DashboardListsProjectsSector from "./Templates/Projects/ListSector";
import DashboardListsSectorOKRs from "./Templates/OKRs/ListSector";
import DashboardListMeetings from "./Templates/Meetings/ListMeetings";
import DashboardSummaryAuditsType from "./Templates/Audits/SummaryType";
import DashboardSummaryAuditsSector from "./Templates/Audits/SummarySector";
import DashboardSummaryAuditsProcess from "./Templates/Audits/SummaryProcess";
import DashboardPieChartAudits from "./Templates/Audits/PieChart";

export const textBadge = (paramFormat: FormatDashboard, translate: (text: string, objKeys?: object | undefined) => string) => {
	let text = "Análises";
	switch(paramFormat){
	case FormatDashboard.ACTIONS:
		text = "Ações";
		break;
	case FormatDashboard.BUSINESS_DIAGNOSIS:
		text = "Diagnósticos";
		break;
	case FormatDashboard.INDICATORS:
		text = "Indicadores";
		break;
	case FormatDashboard.STRATEGIC_PLANNING:
		text = "Planejamento";
		break;
	case FormatDashboard.PROJECT:
		text = "Projetos";
		break;
	case FormatDashboard.OCCURRENCES:
		text = "Ocorrências";
		break;
	case FormatDashboard.AUDITS:
		text = "Auditorias";
		break;
	case FormatDashboard.MEETINGS:
		text = "Reuniões";
		break;
	case FormatDashboard.RISKS:
		text = "Riscos";
		break;
	default: 
		text = "Análises";
		break;
	}
	return translate(text);
};

export const dashboardTemplateToFormat = (id: string): FormatDashboard => {
	const dashboardTemplate = dashboardTemplates.find((x) => x.id === id);

	return dashboardTemplate?.format || FormatDashboard.ACTIONS;
};

export const dashboardTemplateToType = (id: string): TypeDashboardComponents => {
	const dashboardTemplate = dashboardTemplates.find((x) => x.id === id);

	return dashboardTemplate?.type || TypeDashboardComponents.CARD;
};

const dashboardTemplates: IDashboardTemplate[] = [{
	id: "ActionsCard",
	format: FormatDashboard.ACTIONS,
	title: "Andamento Ações por Situação",
	description: "Este card mostra as ações com seus respectivos progressos",
	type: TypeDashboardComponents.CARD,
	component: DashboardCardsActions,
	src: actionsCard
},{
	id: "ActionsList",
	format: FormatDashboard.ACTIONS,
	title: "Resumo Ações por Origem",
	description: "Esta listagem mostra as ações agrupadas pela origem com seus respectivos progressos",
	type: TypeDashboardComponents.LIST,
	component: DashboardListsActions,
	src: actionsList
},{
	id: "ActionsChart",
	format: FormatDashboard.ACTIONS,
	title: "Gráfico Ações por Origem",
	description: "Este gráfico mostra as ações agrupadas pela origem com seus respectivos progressos",
	type: TypeDashboardComponents.CHART,
	component: DashboardChartActions,
	src: actionsChart
},{
	id: "MyActions",
	format: FormatDashboard.ACTIONS,
	title: "Lista Minhas Ações Recentes",
	description: "Esta listagem mostra as ações em aberto no início da semana passada até o fim da semana atual, filtrando o usuário responsável",
	type: TypeDashboardComponents.LIST_2,
	component: DashboardListMyActionsActions,
	src: myActionsList
},{
	id: "ActionsLastSevenDays",
	format: FormatDashboard.ACTIONS,
	title: "Ações Recentes",
	description: "Esta listagem mostra as ações em aberto no início da semana passada até o fim da semana atual",
	type: TypeDashboardComponents.LIST_3,
	component: DashboardListActionsActions,
	src: myActionsList
},{
	id: "WeeklyActionsPie",
	format: FormatDashboard.ACTIONS,
	title: "Gráfico Ações Recentes por Situação",
	description: "Esta listagem mostra as ações em aberto no início da semana passada até o fim da semana atual",
	type: TypeDashboardComponents.PIE,
	component: DashboardPieChartActions,
	src: actionsPieChart
},{
	id: "ActionsListSector",
	format: FormatDashboard.ACTIONS,
	title: "Resumo Ações por Setor",
	description: "Esta listagem mostra as ações agrupadas pelo setor com seus respectivos progressos",
	type: TypeDashboardComponents.LIST_4,
	component: DashboardListsActionsSector,
	src: actionsListSector
},{
	id: "BusinessDiagnosisCard",
	format: FormatDashboard.BUSINESS_DIAGNOSIS,
	title: "Card de Diagnóstico de Negócio",
	description: "Este card seleciona o percentual obtido do diagnóstico de negócio mais próximo da data atual, sem contar datas futuras",
	type: TypeDashboardComponents.CARD,
	component: BusinessDiagnosisCards,
	src: businessDiagnosis
},{
	id: "CanvasCard",
	format: FormatDashboard.BUSINESS_DIAGNOSIS,
	title: "Card de Canvas",
	description: "Este card seleciona quantas áreas foram preenchidas no canvas mais recente",
	type: TypeDashboardComponents.CARD,
	component: CanvasCards,
	src: canvas
},{
	id: "IndicatorsCard",
	format: FormatDashboard.INDICATORS,
	title: "Andamento Indicadores",
	description: "Este card mostra os indicadores com seus respectivos progressos",
	type: TypeDashboardComponents.CARD,
	component: DashboardCardsIndicators,
	src: indicatorsCard
},{
	id: "IndicatorsChartClassification",
	format: FormatDashboard.INDICATORS,
	title: "Gráfico Indicadores por Classificação",
	description: "Este gráfico mostra os indicadores agrupados pela classificação com seus respectivos progressos",
	type: TypeDashboardComponents.CHART_2,
	component: DashboardChartClassificationIndicators,
	src: indicatorsChart
},{
	id: "IndicatorsChart",
	format: FormatDashboard.INDICATORS,
	title: "Gráfico Indicadores por Nível",
	description: "Este gráfico mostra os indicadores agrupados pelo nível com seus respectivos progressos",
	type: TypeDashboardComponents.CHART,
	component: DashboardChartIndicators,
	src: indicatorsChart
},{
	id: "IndicatorsGauge",
	format: FormatDashboard.INDICATORS,
	title: "Medidor Indicador",
	description: "Este gráfico mostra o valor de um indicador específico",
	type: TypeDashboardComponents.GAUGE,
	component: DashboardGaugeIndicators,
	src: indicatorsGauge
},{
	id: "IndicatorsListClassification",
	format: FormatDashboard.INDICATORS,
	title: "Resumo Indicadores por Classificação",
	description: "Esta listagem mostra os indicadores agrupados pela classificação com seus respectivos progressos",
	type: TypeDashboardComponents.LIST_2,
	component: DashboardListClassificationIndicators,
	src: indicatorsList
},{
	id: "IndicatorsList",
	format: FormatDashboard.INDICATORS,
	title: "Resumo Indicadores por Nível",
	description: "Esta listagem mostra os indicadores agrupados pelo nível com seus respectivos progressos",
	type: TypeDashboardComponents.LIST,
	component: DashboardListsIndicators,
	src: indicatorsList
},{
	id: "IndicatorsListSector",
	format: FormatDashboard.INDICATORS,
	title: "Resumo Indicadores por Setor",
	description: "Esta listagem mostra os indicadores agrupados pelo setor com seus respectivos progressos",
	type: TypeDashboardComponents.LIST_3,
	component: DashboardListsIndicatorsSectors,
	src: indicatorsListSector
},{
	id: "MapsCard",
	format: FormatDashboard.STRATEGIC_PLANNING,
	title: "Card de Mapas",
	description: "Este card mostra o percentual de conclusão do mapa favorito",
	type: TypeDashboardComponents.CARD_3,
	component: MapsCards,
	src: map
},{
	id: "OkrsCard",
	format: FormatDashboard.STRATEGIC_PLANNING,
	title: "Detalhe OKR",
	description: "Este card mostra o percentual de conclusão do okr selecionado ou a média de todos os okr's de primeiro nivel",
	type: TypeDashboardComponents.CARD,
	component: OKRsCards,
	src: okrsCard
},{
	id: "OkrsCardWithKRs",
	format: FormatDashboard.STRATEGIC_PLANNING,
	title: "Detalhe OKR com Resultado Chave",
	description: "Este card mostra o okr com seus respectivos resultados chave",
	type: TypeDashboardComponents.CARD_2,
	component: DashboardCardsOKRWithKRs,
	src: okrsCardWithKrs
},{
	id: "OkrsList",
	format: FormatDashboard.STRATEGIC_PLANNING,
	title: "Resumo de OKRs por Nível",
	description: "Esta listagem mostra os números de okrs agrupados pelo nível",
	type: TypeDashboardComponents.LIST,
	component: DashboardListClassificationOKRs,
	src: okrsList
},
{
	id: "OkrsListSector",
	format: FormatDashboard.STRATEGIC_PLANNING,
	title: "Resumo de OKRs por Setor",
	description: "Esta listagem mostra os números de okrs agrupados pelo setor",
	type: TypeDashboardComponents.LIST_2,
	component: DashboardListsSectorOKRs,
	src: okrsListSector
},{
	id: "ProjectCardPercentage",
	format: FormatDashboard.PROJECT,
	title: "Andamento Projetos",
	description: "Esta card mostra o percentual de andamento de projetos",
	type: TypeDashboardComponents.CARD_2,
	component: DashboardCardsProjectsPercentage,
	src: projectsCardPercentage
},{
	id: "ProjectCardPercentageOfProgram",
	format: FormatDashboard.PROJECT,
	title: "Andamento Projetos por Programa",
	description: "Esta card mostra o percentual de andamento dos projetos de um programa",
	type: TypeDashboardComponents.CARD_3,
	component: DashboardCardsProjectsPercentageOfProgram,
	src: projectsCardPercentageProgram
},{
	id: "ProjectCard",
	format: FormatDashboard.PROJECT,
	title: "Detalhe Projeto",
	description: "Este card mostra o valor de um projeto específico",
	type: TypeDashboardComponents.CARD,
	component: DashboardCardSpecificProject,
	src: projectsCard
},{
	id: "ProjectOfPieChart",
	format: FormatDashboard.PROJECT,
	title: "Gráfico Projeto por Situação",
	description: "Este gráfico pizza mostra o número de projetos para cada uma das situações",
	type: TypeDashboardComponents.PIE_2,
	component: DashboardPieChartProjects,
	src: projectsPieChart
},{
	id: "ProjectOfAProgramPieChart",
	format: FormatDashboard.PROJECT,
	title: "Gráfico Projeto por Situação - Programa",
	description: "Este gráfico pizza mostra o número de projetos para cada uma das situações de um programa",
	type: TypeDashboardComponents.PIE,
	component: DashboardPieChartProjectsOfProgram,
	src: projectsPieChart
},{
	id: "ProjectList",
	format: FormatDashboard.PROJECT,
	title: "Lista Projetos",
	description: "Esta listagem mostra os projetos abertos",
	type: TypeDashboardComponents.LIST,
	component: DashboardListProjects,
	src: projectsListCards
},{
	id: "ProjectListSector",
	format: FormatDashboard.PROJECT,
	title: "Resumo Projetos por Setor",
	description: "Esta listagem mostra os números de projetos agrupados pelo setor",
	type: TypeDashboardComponents.LIST_2,
	component: DashboardListsProjectsSector,
	src: projectsListSector
},{
	id: "SwotCard",
	format: FormatDashboard.ANALYSIS,
	title: "Card de Swot",
	description: "Este card seleciona a SWOT mais recente para visualização de suas forças, fraquezas, oportunidades e ameaças",
	type: TypeDashboardComponents.CARD,
	component: SWOTSCards,
	src: swot
},{
	id: "MyOccurreces",
	format: FormatDashboard.OCCURRENCES,
	title: "Lista Minhas Ocorrencias",
	description: "Esta listagem mostra as ocorrências filtrando o usuário responsável",
	type: TypeDashboardComponents.LIST,
	component: DashboardListMyOccurrences,
	src: myOcurrences
},{
	id: "OccurrecesListOrigin",
	format: FormatDashboard.OCCURRENCES,
	title: "Resumo Ocorrências por Origem",
	description: "Esta listagem mostra as ocorrências agrupados pela origem",
	type: TypeDashboardComponents.CARD,
	component: DashboardListsOccurrences,
	src: occurrecesListCards
},{
	id: "OccurrecesListSector",
	format: FormatDashboard.OCCURRENCES,
	title: "Resumo Ocorrências por Setor",
	description: "Esta listagem mostra as ocorrências agrupados pelo setor",
	type: TypeDashboardComponents.CARD_2,
	component: DashboardListsOccurrencesSector,
	src: occurrencesListCardsSector
},{
	id: "RisksImpact",
	format: FormatDashboard.RISKS,
	title: "Gráfico Riscos por Impacto",
	description: "Este gráfico pizza mostra o impacto dos riscos, estes agrupados por oportunidades e ameaças",
	type: TypeDashboardComponents.PIE,
	component: DashboardPieChartRisksImpact,
	src: risksPieChartImpact 
},
{
	id: "RisksProbability",
	format: FormatDashboard.RISKS,
	title: "Gráfico Riscos por Probabilidade",
	description: "Este gráfico pizza mostra a probabilidade dos riscos, estes agrupados por oportunidades e ameaças",
	type: TypeDashboardComponents.PIE_2,
	component: DashboardPieChartRisksProbability,
	src: risksPieChartProbability 
},
{
	id: "RisksList",
	format: FormatDashboard.RISKS,
	title: "Resumo Riscos por Classificação",
	description: "Esta listagem mostra os riscos agrupados pela classificação",
	type: TypeDashboardComponents.LIST,
	component: DashboardListClassificationRisks,
	src: risksListClassification 
},{
	id: "MeetingsList",
	format: FormatDashboard.MEETINGS,
	title: "Lista Minhas Próximas Reuniões",
	description: "Esta listagem mostra as próximas reuniões em aberto no período de uma semana",
	type: TypeDashboardComponents.LIST,
	component: DashboardListMeetings,
	src: meetingsList 
},{
	id: "AuditsSummaryType",
	format: FormatDashboard.AUDITS,
	title: "Resumo Auditorias por Tipo",
	description: "Esta listagem mostra as auditorias agrupadas pelo tipo com seus respectivos progressos",
	type: TypeDashboardComponents.LIST,
	component: DashboardSummaryAuditsType,
	src: auditsListType 
},{
	id: "AuditsSummarySector",
	format: FormatDashboard.AUDITS,
	title: "Resumo Auditorias por Setor",
	description: "Esta listagem mostra as auditorias agrupadas pelo setor com seus respectivos progressos",
	type: TypeDashboardComponents.LIST_2,
	component: DashboardSummaryAuditsSector,
	src: auditsListSector 
},{
	id: "AuditsSummaryProcess",
	format: FormatDashboard.AUDITS,
	title: "Resumo Auditorias por Processo",
	description: "Esta listagem mostra as auditorias agrupadas pelo processo com seus respectivos progressos",
	type: TypeDashboardComponents.LIST_3,
	component: DashboardSummaryAuditsProcess,
	src: audtisListProcess 
},{
	id: "AuditsPieChart",
	format: FormatDashboard.AUDITS,
	title: "Gráfico Auditorias por Situação",
	description: "Este gráfico mostra as auditorias agrupadas pela situação com seus respectivos progresso",
	type: TypeDashboardComponents.CHART,
	component: DashboardPieChartAudits,
	src: auditsPieChart 
}];

export default dashboardTemplates;
